import { useFlag } from '@components/Flag';

export const useViewSlackEmployeeTreeFlag = (): boolean => {
  const useViewSlackEmployeeTree = useFlag('ME-61741-view-slack-employee-tree');
  return useViewSlackEmployeeTree;
};
